import { history } from '@mssgme/services';

export { tidyFilter } from '@mssgme/helpers';

const regexp = /^\/(?:s\/)?billing/;

export function getBillingRoot() {
    const pathname = history.location.pathname;

    if (regexp.test(pathname)) {
        return (pathname.startsWith('/s/') ? '/s' : '') + '/billing';
    }
}
